module.exports = "<nb-auth-block>\n  <img src=\"assets/logo.png\" class=\"logo\" />\n  <small class=\"form-text sub-title\">Aguarde.</small>\n</nb-auth-block>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/components/login-key/login_key.component.html
// module id = ./src/app/auth/components/login-key/login_key.component.html
// module chunks = main